export function formatDateOnly(dateTime, locale = "en-GB") {
  const date = new Date(dateTime);
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date format");
  }
  return date.toLocaleDateString(locale); 
}

export const normalizeQuickRange = (range) => {
  if (!range) return { startDate: "", endDate: "" };
  const [s, e] = range.split(",");
  const norm = (x) => (x ? x.trim().replace(/\//g, "-") : "");
  return { startDate: norm(s), endDate: norm(e) };
};


export const generateMonthRanges=(monthsBack = 12)=>{
  const ranges = [];
  const today = new Date();

  for (let i = 0; i < monthsBack; i++) {
    // Always go to the 1st day of the target month
    const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    const year = d.getFullYear();
    const month = d.getMonth(); // 0-indexed

    // ✅ last day of month
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Format YYYY-MM-DD
    const start = `${year}-${String(month + 1).padStart(2, "0")}-01`;
    const end = `${year}-${String(month + 1).padStart(2, "0")}-${daysInMonth}`;

    ranges.push({
      label: `${start} - ${end}`,
      value: `${start},${end}` // payload-ready
    });
  }

  return ranges;
}

const PROXY_MAPPINGS = [
  {
    base: import.meta.env.VITE_BASE_IMAGE_URL,
    proxy: "/imageproxy/images/activity_images/"
  },
  {
    base: import.meta.env.VITE_EXPENSES_URL,
    proxy: "/imageproxy/images/expense_files/"
  }
  // Add more folders here without touching the logic
];

// export const getProxyImageUrl = (url) => {

//   if (!url) return null;

//   // already proxied
//   if (url.startsWith("/imageproxy/")) return url;

//   // backend sent only filename
//   if (!url.startsWith("http")) {
//     return "/imageproxy/images/activity_images/" + url;
//   }

//   // check in mappings
//   for (const map of PROXY_MAPPINGS) {
//     if (map.base && url.startsWith(map.base)) {
//       return url.replace(map.base, map.proxy);
//     }
//   }

//   // fallback (http files from external sources)
//   return url;
// };



export const getProxyImageUrl = (url) => {
  const BASE_IMAGE_URL = import.meta.env.VITE_BASE_IMAGE_URL || '';
  const BASE_EXPENSE_URL = import.meta.env.VITE_EXPENSES_URL || '';

  if (!url) return null;

  // ✅ If already proxied, don't modify
  if (url.startsWith("/imageproxy/")) {
    return url;
  }

  // ✅ Use BASE_EXPENSE_URL if file name/path contains specific keywords
  const lowerUrl = url.toLowerCase();
  if (
    lowerUrl.includes("hotel_bill") ||
    lowerUrl.includes("activity_bill") ||
    lowerUrl.includes("approval_document")
  ) {
    // If absolute expense URL
    if (url.startsWith(BASE_EXPENSE_URL)) {
      return url.replace(BASE_EXPENSE_URL, "/imageproxy/images/expense_files/");
    }

    // If relative path
    if (!url.startsWith("http")) {
      return "/imageproxy/images/expense_files/" + url;
    }
  }

  // ✅ Handle standard activity images
  if (url.startsWith(BASE_IMAGE_URL)) {
    return url.replace(BASE_IMAGE_URL, "/imageproxy/images/activity_images/");
  }

  // ✅ If relative and doesn’t match expense pattern → assume activity image
  if (!url.startsWith("http")) {
    return "/imageproxy/images/activity_images/" + url;
  }

  return url;
};




// ------------------ Role-based menu filter ------------------
export const filterByRole = (menu, roleID) => {
  if (!menu) return null;

  const roleAccess = JSON.parse(localStorage.getItem("role_access") || "[]");
  const companyAccess = JSON.parse(localStorage.getItem("company_access") || "[]");

  // find company menu by title
  const companyMenu = companyAccess.find(
    (x) => x.name.trim().toLowerCase() === menu.title.trim().toLowerCase()
  );

  // ROLE: menu allowed?
  const roleMenuAllowed = roleAccess.some(
    (x) =>
      x.role_id == roleID &&
      x.menu_name?.trim().toLowerCase() === menu.title.trim().toLowerCase() &&
      x.allowed === true
  );

  // COMPANY: menu allowed?
  const companyMenuAllowed = companyMenu?.allowed === true;

  const isMenuAllowed = roleMenuAllowed && companyMenuAllowed;

  // ---------- SUBMENUS ----------
  if (Array.isArray(menu.children)) {
    const allowedChildren = menu.children
      .map((child) => {
        const childRoleAllowed = roleAccess.some(
          (x) =>
            x.role_id == roleID &&
            x.submenu_name?.trim().toLowerCase() === child.title.trim().toLowerCase() &&
            x.allowed === true
        );

        const childCompanyAllowed = companyMenu?.submenus?.some(
          (s) =>
            s.name.trim().toLowerCase() === child.title.trim().toLowerCase() &&
            s.allowed === true
        );

        return childRoleAllowed && childCompanyAllowed ? child : null;
      })
      .filter(Boolean);

    // If menu allowed OR any submenu allowed → show menu
    if (isMenuAllowed || allowedChildren.length > 0) {
      return { ...menu, children: allowedChildren };
    }

    return null;
  }

  const roleSubmenuAllowed = roleAccess.some(
    (x) =>
      x.role_id == roleID &&
      x.submenu_name?.trim().toLowerCase() === menu.title.trim().toLowerCase() &&
      x.allowed === true
  );

  const companySubmenuAllowed = companyMenu?.submenus?.some(
    (s) =>
      s.name.trim().toLowerCase() === menu.title.trim().toLowerCase() &&
      s.allowed === true
  );

  return roleSubmenuAllowed && companySubmenuAllowed ? menu : null;
};
export const formatDateDMY = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};


export const calculateTotals = (columnsOrKeys, data = []) => {
  if (!data || !data.length) {
    return { totalsByKey: {}, totalKeys: [], columns: columnsOrKeys };
  }

  const totalKeys =
    Array.isArray(columnsOrKeys) && columnsOrKeys.length && typeof columnsOrKeys[0] === "string"
      ? columnsOrKeys
      : Array.isArray(columnsOrKeys)
      ? columnsOrKeys.map(c => c.key).filter(Boolean)
      : [];

  const totalsByKey = {};

  const parseNumber = (v) => {
    if (v === null || v === undefined || v === "") return 0;
    const cleaned = String(v).replace(/,/g, "");
    const n = Number(cleaned);
    return Number.isFinite(n) ? n : 0;
  };

  totalKeys.forEach(key => {
    const sum = data.reduce((acc, row) => {
      return acc + parseNumber(row[key]);
    }, 0);

    // ✅ round to 2 decimals
    totalsByKey[key] = Number(sum.toFixed(2));
  });

  return { totalsByKey, totalKeys, columns: columnsOrKeys };
};
